import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface ActiveNoteData {
  noteId: string;
  structuredNoteDisplayId: string;
  issuedAt: string;
  maturityDate: string;
  tenure: number;
  l2PlusE: string;
  outstandingAmount: string;
  repaidAmount: string;
}

export interface MerchantActiveNotes {
  merchantOrgRoleId: string;
  merchantName: string;
  notes: ActiveNoteData[];
}

export interface GetActiveNotesResponse {
  merchants: MerchantActiveNotes[];
}

const getActiveNotes = async (
  token: string,
): Promise<GetActiveNotesResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/dashboard/active-notes`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default getActiveNotes;
